import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { ellipsis } from '@synoptic/ui-kit/utility.css.ts';
import { style } from '@vanilla-extract/css';

export const bannerHeader = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    gap: space.s16,
  },
]);

export const headerContent = style([
  {
    display: 'flex',
    gap: space.s8,
    marginBottom: space.s8,
    overflow: 'hidden',
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column-reverse',
      alignItems: 'start',
    },
    tablet: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  }),
]);

export const createdByContainer = style([
  ellipsis,
  typography.bodyMd,
  {
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
    color: themeVars.container.foreground.secondary,
  },
]);

export const avatarLink = style([
  {
    flexShrink: 0,
  },
]);

export const createdBy = style([ellipsis]);

export const streamAuthorLink = style([
  {
    whiteSpace: 'nowrap',

    selectors: {
      [`${createdByContainer}:hover &`]: {
        textDecoration: 'underline',
      },
    },
  },
]);

export const verticalSeparator = style([
  {
    width: 1.5,
    height: 14,
    background: themeVars.container.foreground.secondary,
    margin: `0 ${space.s4}px`,
    flexShrink: 0,
  },
]);

export const apiAccessLabel = style([
  typography.bodyMd,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s4,
    color: themeVars.container.foreground.secondary,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
]);

export const apiAccessLabelDisabled = style([
  apiAccessLabel,
  {
    color: themeVars.container.foreground.tertiary,
  },
]);
